export const reduceBnSum = (acc, next) => acc.add(next);
